const CRITERIA = [
  "Budget alignment",
  "Preferred city & building",
  "Months you each plan to use",
  "Peak holiday expectations",
  "Religious & lifestyle observance",
  "Family profile",
  "Long‑term intentions",
];

export default function Matching() {
  return (
    <section
      id="matching"
      data-testid="matching-section"
      className="relative bg-[var(--bone)] text-[var(--ink)]"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-44">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 lg:col-start-1 reveal">
            <div className="relative overflow-hidden border border-[var(--border-soft)]">
              <img
                src="https://images.unsplash.com/photo-1505577058444-a3dab90d4253?auto=format&fit=crop&w=1400&q=80"
                alt="A sunlit Mediterranean apartment interior with linen drapes"
                className="w-full h-[460px] md:h-[620px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/40 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-[var(--bone)]">
                <div className="text-overline text-[var(--gold)]">A quiet morning in</div>
                <div className="font-serif-display text-2xl md:text-3xl italic">Tel Aviv</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <div className="text-overline text-[var(--ink)]/55 mb-6">Matching matters</div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.6rem] leading-[1.05] tracking-tight">
              The secret is <span className="italic text-[var(--gold)]">who you share with.</span>
            </h2>
            <p className="mt-7 md:mt-9 text-[var(--ink)]/72 text-base md:text-lg leading-relaxed font-light max-w-xl">
              Most co‑ownership stories fail in the small print of human compatibility, not the legal one.
              Our proprietary matching system scores each family across seven dimensions — privately,
              transparently, and with deep care.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
              {CRITERIA.map((c, i) => (
                <li key={c} className="flex items-baseline gap-3 reveal" style={{ transitionDelay: `${i * 0.05}s` }}>
                  <span className="font-serif-display text-[var(--gold)] text-lg leading-none">·</span>
                  <span className="text-[var(--ink)]/85 text-base md:text-lg font-light">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
